export const Common = {
  link: "garden-link",
  hashtagLink: "garden-hashtag-link",
}

export const Block = {
  referenceContent: "reference-content",
  embed: "block-embed",
  reference: "block-reference",
}
